module.exports = "static/assets/831a9fd5f488f356a5031c289e4c35fe.svg";